/* JR 2 - carrito: regalos como propiedad de línea y caja original (cantidad libre, sin límite). */
(function () {
'use strict';
var R = window.routes || {};
var URLS = { add: R.cart_add_url || '/cart/add.js', change: R.cart_change_url || '/cart/change.js', update: R.cart_update_url || '/cart/update.js', cart: R.cart_url || '/cart' };
var PROP_GIFT = 'Regalo', PROP_BOX = 'Caja original', PROP_BOX_VID = '_caja_variant';
function $(sel, root) { return (root || document).querySelector(sel); }
function drawerEl() { return $('cart-drawer'); }
function pageEl() { return $('cart-items'); }
var rawFrame = null;
function rawFetch() {
 try {
  if (!rawFrame || !rawFrame.isConnected || !rawFrame.contentWindow) {
   rawFrame = document.createElement('iframe');
   rawFrame.setAttribute('aria-hidden', 'true');
   rawFrame.tabIndex = -1;
   rawFrame.style.display = 'none';
   rawFrame.src = 'about:blank';
   (document.body || document.documentElement).appendChild(rawFrame);
  }
  var w = rawFrame.contentWindow;
  if (w && typeof w.fetch === 'function') return w.fetch.bind(w);
 } catch (e) {}
 return window.fetch.bind(window);
}
function request(url, payload, quiet) {
 var f = quiet ? rawFetch() : window.fetch.bind(window);
 return f(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
  .then(function (r) { return r.json(); })
  .then(function (data) {
   if (data && data.status && data.status >= 400) { throw new Error(data.description || data.message || ('HTTP ' + data.status)); }
   return data;
  });
}
function json(url, payload) { return request(url, payload, false); }
function qjson(url, payload) { return request(url, payload, true); }
function cartGet() {
 var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 return rawFetch()(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
}
function getSectionInner(html, selector) {
 var doc = new DOMParser().parseFromString(html || '', 'text/html');
 var el = doc.querySelector(selector) || doc.body;
 return el ? el.innerHTML : '';
}
function sectionIds() {
 var ids = ['cart-drawer', 'cart-icon-bubble'];
 var page = pageEl();
 if (page && typeof page.getSectionsToRender === 'function') {
  try { page.getSectionsToRender().forEach(function (s) { if (ids.indexOf(s.section) === -1) ids.push(s.section); }); } catch (e) {}
 }
 return ids;
}
function withSections(payload) { payload.sections = sectionIds(); payload.sections_url = window.location.pathname; return payload; }
function fetchState() { return qjson(URLS.update, withSections({ updates: {} })); }
function renderDrawer(state, open) {
 var d = drawerEl();
 if (!d || !state || !state.sections || !state.sections['cart-drawer']) return false;
 var target = $('#CartDrawer');
 if (target) target.innerHTML = getSectionInner(state.sections['cart-drawer'], '#CartDrawer');
 var bubble = document.getElementById('cart-icon-bubble');
 if (bubble && state.sections['cart-icon-bubble']) bubble.innerHTML = getSectionInner(state.sections['cart-icon-bubble'], '.shopify-section');
 var empty = state.item_count === 0;
 d.classList.toggle('is-empty', empty);
 var inner = d.querySelector('.drawer__inner');
 if (inner) inner.classList.toggle('is-empty', empty);
 var items = d.querySelector('cart-drawer-items');
 if (items) items.classList.toggle('is-empty', empty);
 var ov = $('#CartDrawer-Overlay');
 if (ov) ov.addEventListener('click', d.close.bind(d));
 if (open) setTimeout(function () { try { d.open(); } catch (e) { d.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); } });
 return true;
}
function renderPage(state) {
 var page = pageEl();
 if (!page || !state || !state.sections || typeof page.getSectionsToRender !== 'function') return false;
 page.getSectionsToRender().forEach(function (section) {
  var html = state.sections[section.section];
  if (!html) return;
  var root = document.getElementById(section.id);
  if (!root) return;
  var target = root.querySelector(section.selector) || root;
  target.innerHTML = getSectionInner(html, section.selector);
 });
 var empty = state.item_count === 0;
 page.classList.toggle('is-empty', empty);
 var footer = document.getElementById('main-cart-footer');
 if (footer) footer.classList.toggle('is-empty', empty);
 return true;
}
function rerender(state, opts) {
 opts = opts || {};
 var onPage = !!pageEl();
 var ok = false;
 if (onPage) ok = renderPage(state);
 if (renderDrawer(state, !onPage && !opts.silent)) ok = true;
 if (!ok) window.location.reload();
}
function stateEl(root) {
 root = root || document;
 return $('cart-items .jr-cart-state', root) || $('cart-drawer .jr-cart-state', root) || $('.jr-cart-state', root);
}
function parsePairs(str, sep, kv) {
 return (str || '').split(sep).filter(Boolean).map(function (t) {
  var i = t.lastIndexOf(kv);
  return { k: t.slice(0, i), v: +t.slice(i + 1) || 0 };
 });
}
function readState(root) {
 var s = stateEl(root);
 if (!s) return { present: false, w: 0, fix: [], legacy: [], boxes: [], giftFull: '', giftEbook: '' };
 var d = s.dataset;
 var need = {}, cur = {};
 parsePairs(d.boxNeed, ',', ':').forEach(function (p) { need[p.k] = (need[p.k] || 0) + p.v; });
 parsePairs(d.boxCur, ',', ':').forEach(function (p) { cur[p.k] = (cur[p.k] || 0) + p.v; });
 var boxes = [];
 Object.keys(need).concat(Object.keys(cur)).forEach(function (vid) {
  if (!vid || boxes.some(function (b) { return b.vid === vid; })) return;
  boxes.push({ vid: vid, need: need[vid] || 0, cur: cur[vid] || 0 });
 });
 return {
  present: true,
  w: +d.watches || 0,
  fix: parsePairs(d.fixLines, ';', '|').map(function (p) { return { key: p.k, qty: p.v }; }),
  legacy: parsePairs(d.legacy, ',', ':').map(function (p) { return { vid: p.k, qty: p.v }; }),
  boxes: boxes,
  war: { cur: +d.warCur || 0, vid: d.warVid || '' },
  giftFull: d.giftFull || 'Caja de regalo de cuero + E-book El Manual del Reloj',
  giftEbook: d.giftEbook || 'E-book El Manual del Reloj'
 };
}
function texts() { var s = readState(); return { giftFull: s.giftFull, giftEbook: s.giftEbook }; }
var busyFlag = false, pending = false, attempts = [];
function reconcile() {
 if (busyFlag) { pending = true; return; }
 var s = readState();
 if (!s.present) return;
 var updates = {}, adds = [];
 s.legacy.forEach(function (l) { updates[l.vid] = 0; });
 s.boxes.forEach(function (b) {
  if (b.cur > b.need && b.need === 0) updates[b.vid] = 0;
  else if (b.cur < b.need) adds.push({ id: Number(b.vid), quantity: b.need - b.cur });
 });
 if (s.war.vid && s.war.cur > 0) {
  if (s.w === 0) updates[s.war.vid] = 0;
  else if (s.war.cur > 1) updates[s.war.vid] = 1;
 }
 var hasFix = s.fix.length > 0, hasUpd = Object.keys(updates).length > 0, hasAdd = adds.length > 0;
 if (!hasFix && !hasUpd && !hasAdd) return;
 var now = Date.now();
 attempts = attempts.filter(function (t) { return now - t < 15000; });
 if (attempts.length >= 6) { console.warn('[jr-cart] reconcile: demasiados intentos, freno'); return; }
 attempts.push(now);
 busyFlag = true;
 var chain = Promise.resolve();
 if (hasFix) {
  var fixProps = {}; fixProps[PROP_GIFT] = s.giftFull;
  chain = chain.then(function () { return setProps(s.fix.map(function (f) { return f.key; }).join(','), fixProps); });
 }
 if (hasUpd) chain = chain.then(function () { return qjson(URLS.update, { updates: updates }); });
 if (hasAdd) chain = chain.then(function () { return json(URLS.add, { items: adds }); });
 chain.then(fetchState)
  .then(function (state) { rerender(state, { silent: true }); })
  .catch(function (e) { console.error('[jr-cart] reconcile', e); })
  .finally(function () { busyFlag = false; if (pending) { pending = false; setTimeout(reconcile, 60); } });
}
function setProps(keys, props) {
 var chain = Promise.resolve();
 String(keys || '').split(',').filter(Boolean).forEach(function (key) {
  chain = chain.then(function () {
   return qjson(URLS.change, { id: key, properties: props }).catch(function (e) { console.warn('[jr-cart] props', key, e); });
  });
 });
 return chain;
}
function busy(el, on) { if (!el) return; el.classList.toggle('loading', !!on); if ('disabled' in el) el.disabled = !!on; }
function addItems(items, opts) {
 opts = opts || {};
 return json(URLS.add, withSections({ items: items })).then(function (state) { rerender(state, { silent: !!opts.silent }); return state; });
}
function onAddRec(btn) {
 var vid = Number(btn.dataset.variantId), qty = parseInt(btn.dataset.qty || '1', 10) || 1;
 if (!vid) return;
 busy(btn, true);
 var props = {}; props[PROP_GIFT] = texts().giftFull;
 addItems([{ id: vid, quantity: qty, properties: props }]).catch(function (e) { busy(btn, false); console.error('[jr-cart] add', e); });
}
function fmtMoney(cents) {
 try { return '$' + Math.round(cents / 100).toLocaleString('es-AR'); } catch (e) { return '$' + Math.round(cents / 100); }
}
function onBoxStep(btn) {
 var card = btn.closest('[data-jr-box-card]');
 if (!card) return;
 var unit = parseInt(card.dataset.unit || '0', 10) || 0;
 var out = card.querySelector('[data-jr-box-qty]');
 var cta = card.querySelector('[data-jr-box-add]');
 var minus = card.querySelector('[data-jr-box-minus]');
 var cur = parseInt((out && out.textContent) || '1', 10) || 1;
 var n = cur + (btn.hasAttribute('data-jr-box-plus') ? 1 : -1);
 n = Math.max(1, n);
 if (out) out.textContent = String(n);
 if (cta) {
  cta.dataset.qty = String(n);
  var tot = cta.querySelector('[data-jr-box-total]');
  if (tot) tot.textContent = '+ ' + fmtMoney(unit * n);
 }
 if (minus) minus.disabled = n <= 1;
}
function groupLines(cart, watchVid, ref) {
 return ((cart && cart.items) || []).filter(function (i) {
  var p = i.properties || {};
  return String(i.variant_id) === String(watchVid) && (p[PROP_GIFT] || '') === ref.gift && (p[PROP_BOX_VID] || '') === ref.box;
 });
}
function trimGroup(watchVid, ref, left) {
 if (left <= 0) return Promise.resolve();
 return cartGet().then(function (c) {
  var ls = groupLines(c, watchVid, ref), last = ls[ls.length - 1];
  if (!last) return;
  var dec = Math.min(last.quantity, left);
  return qjson(URLS.change, { id: last.key, quantity: last.quantity - dec }).then(function () { return trimGroup(watchVid, ref, left - dec); });
 });
}
function boxGroup(watchVid, ref, props, guard) {
 if (guard <= 0) return Promise.resolve();
 return cartGet().then(function (c) {
  var ls = groupLines(c, watchVid, ref);
  if (!ls.length) return;
  return qjson(URLS.change, { id: ls[0].key, properties: props }).then(function () { return boxGroup(watchVid, ref, props, guard - 1); });
 });
}
function onBoxAdd(btn) {
 var keys = btn.dataset.lineKeys, vid = Number(btn.dataset.variantId), qty = parseInt(btn.dataset.qty || '1', 10) || 1;
 var title = btn.dataset.boxTitle || '';
 if (!keys || !vid) return;
 busy(btn, true);
 busyFlag = true;
 var t = texts(), props = {};
 props[PROP_GIFT] = t.giftEbook;
 props[PROP_BOX] = title;
 props[PROP_BOX_VID] = String(vid);
 cartGet().then(function (cart) {
  var items = (cart && cart.items) || [];
  var first = String(keys).split(',').filter(Boolean).map(function (k) {
   return items.filter(function (i) { return i.key === k; })[0];
  }).filter(Boolean)[0];
  if (!first) throw new Error('grupo no encontrado');
  var fp = first.properties || {};
  var ref = { gift: fp[PROP_GIFT] || '', box: fp[PROP_BOX_VID] || '' };
  var watchVid = first.variant_id;
  var origProps = {};
  Object.keys(fp).forEach(function (k) { origProps[k] = fp[k]; });
  var total = groupLines(cart, watchVid, ref).reduce(function (a, l) { return a + l.quantity; }, 0);
  var n = Math.max(1, qty);
  var linked = Math.min(n, total || n);
  var extra = total - linked;
  return trimGroup(watchVid, ref, extra)
   .then(function () { return boxGroup(watchVid, ref, props, 4); })
   .then(function () {
    if (extra > 0) return qjson(URLS.add, { items: [{ id: watchVid, quantity: extra, properties: origProps }] });
   })
   .then(function () { return n; });
 })
  .then(function (n) { return json(URLS.add, { items: [{ id: vid, quantity: n }] }); })
  .then(fetchState)
  .then(function (state) { rerender(state, { silent: true }); })
  .catch(function (e) { busy(btn, false); console.error('[jr-cart] box add', e); })
  .finally(function () { busyFlag = false; if (pending) { pending = false; setTimeout(reconcile, 60); } });
}
function onBoxRemove(btn) {
 var keys = btn.dataset.lineKeys, vid = String(btn.dataset.variantId || ''), qty = parseInt(btn.dataset.qty || '1', 10) || 1;
 if (!keys || !vid) return;
 busy(btn, true);
 var s = readState(), props = {};
 props[PROP_GIFT] = s.giftFull;
 var box = s.boxes.filter(function (b) { return b.vid === vid; })[0];
 var newQty = Math.max((box ? box.cur : 0) - qty, 0);
 setProps(keys, props)
  .then(function () { var u = {}; u[vid] = newQty; return qjson(URLS.update, { updates: u }); })
  .then(fetchState)
  .then(function (state) { rerender(state, { silent: true }); })
  .catch(function (e) { busy(btn, false); console.error('[jr-cart] box remove', e); });
}
function onWarranty(input) {
 var vid = Number(input.dataset.variantId);
 if (!vid) return;
 var on = input.checked;
 input.disabled = true;
 var p;
 if (on) { p = qjson(URLS.add, { items: [{ id: vid, quantity: 1 }] }); }
 else { var u = {}; u[vid] = 0; p = qjson(URLS.update, { updates: u }); }
 p.then(fetchState)
  .then(function (state) { rerender(state, { silent: true }); })
  .catch(function (e) { input.disabled = false; input.checked = !on; console.error('[jr-cart] garantía', e); });
}
document.addEventListener('click', function (ev) {
 var t = ev.target;
 if (!t || !t.closest) return;
 var el;
 if ((el = t.closest('[data-jr-box-minus],[data-jr-box-plus]'))) { ev.preventDefault(); onBoxStep(el); return; }
 if ((el = t.closest('[data-jr-box-add]'))) { ev.preventDefault(); onBoxAdd(el); return; }
 if ((el = t.closest('[data-jr-box-remove]'))) { ev.preventDefault(); onBoxRemove(el); return; }
 if ((el = t.closest('[data-jr-add]'))) { ev.preventDefault(); onAddRec(el); return; }
});
document.addEventListener('change', function (ev) {
 var t = ev.target;
 if (t && t.matches && t.matches('[data-jr-warranty]')) onWarranty(t);
});
var timer;
function tick() { reconcile(); }
function start() {
 tick();
 new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(tick, 150); }).observe(document.body, { childList: true, subtree: true });
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.JRCart = { addItems: addItems, readState: readState, reconcile: reconcile, rerender: rerender, texts: texts };
})();
